<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Timesheet Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="timesheetDate"
                    name="timesheetDate"
                    required
                    [maxDate]="maxDate"
                    #day="ngModel"
                    [(ngModel)]="timesheet.day"
                    [disabled]="!canModifyPastTimeSheet()"
                    [class.field-error]="form.submitted && day.invalid"></p-calendar>
        <label for="timesheetDate" class="required-field">Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && day.invalid">Date is required</small>
    </div>

    <!--Job Codes -->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-dropdown [options]="jobCodes" 
                    inputid="jobCode"
                    name="jobCode"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="jobCodeNo"
                    dataKey="id"
                    required
                    #jobCode="ngModel"
                    [autoDisplayFirst]="false"
                    [filter]="true" filterBy="jobCodeNo" 
                    [(ngModel)]="timesheet.jobCode"
                    [class.field-error]="form.submitted && jobCode.invalid"></p-dropdown>
        <label for="jobCode" class="required-field">Job Code</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && jobCode.invalid">Job code is required!</small>
    </div>

    <!--Work Shits -->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown [options]="rosterCodes" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="shift"
                    name="shift"
                    optionLabel="code"
                    dataKey="id"
                    required
                    #shift="ngModel"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="timesheet.shift"
                    [class.field-error]="form.submitted && shift.invalid">
            <ng-template let-workshift pTemplate="item">
              <div>
                <span style="display:inline-block;width:40px;">{{workshift.code}}:</span> {{workshift.description}}</div>
            </ng-template>                    
          </p-dropdown>
        <label for="shift" class="required-field">Work Shift</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && shift.invalid">Work shift is required!</small>
    </div>

    <!--Man hour-->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputNumber  name="hours"
                        id="hours" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #hour="ngModel"
                        [class.field-error]="form.submitted && hour.invalid"
                        [(ngModel)]="timesheet.hours"></p-inputNumber>
        <label for="hours" class="required-field">Man Hour</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && hour.invalid">Man hour is required!</small>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Note -->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <textarea pInputTextarea
                  id="note"
                  name="note"
                  class="p-inputtext-sm"
                  rows="5"
                  maxlength="500"
                  #note="ngModel"
                  [class.field-error]="form.submitted && note.invalid"
                  [(ngModel)]="timesheet.note"></textarea>
        <label for="hours">Note</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && note.invalid">Max length of note is 500 characters!</small>
    </div>
  </div>


  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel();"></button>
  </div>
</form>

